// extracted by mini-css-extract-plugin
export default {"label":"rectangle-input__label___FeBE_","input":"rectangle-input__input___kSKOx","inputError":"rectangle-input__inputError___RzCTy"};